<template>
  <!-- v3 caps the dialog at 90% of the viewport but leaves its content overflow visible, so a tall image ran off-screen -->
  <v-dialog
    v-model="showDialog"
    max-width="80%"
    :opacity="0.8"
    content-class="overflow-y-auto"
  >
    <v-img v-if="imageUrl" :src="imageUrl" :cover="false" />
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { DialogMixin } from '@/bundles/Dialogs/mixins/DialogMixin';

export default defineComponent({
  name: 'PhotoViewer',
  mixins: [DialogMixin],

  props: {
    imageUrl: {
      type: String,
      default: null,
    }
  },
});
</script>
